module.exports = __webpack_public_path__ + "img/Group 1043two.a5e681d7.png";